import { Injectable } from '@angular/core';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class Base64Service {

  
  encodeString(value: string) {
    return Base64.encode(value);
  }

  decodeString(value: string) {
    try {
      return Base64.decode(value);
    } catch (error) {
      return false;
    }
  }
}
